import { DateTime } from 'luxon'

import { SignedRouteParams } from '@/common/models/signed-route-params'

const ads = {
    index: 'api/ads'
}

const blog = {
    byCategory (categorySlug: string, page: number): string {
        return `api/blog/category/${categorySlug}?page=${page}`
    },
    bySlug (slug: string, params?: SignedRouteParams): string {
        const queryString = params ? `?expires=${params.expires}&signature=${params.signature}` : ''

        return `api/blog/show/${slug}${queryString}`
    },
    index (page: number, notPublished = false, categorySlug?: string): string {
        let ret = `api/blog?page=${page}`

        if (notPublished) ret += '&not_published'
        if (categorySlug !== undefined) ret += `&category=${categorySlug}`

        return ret
    }
}

const categories = {
    index: 'api/categories'
}

const chat = {
    store: 'api/chat/message',
    messages (page: number): string {
        return `api/chat/messages?page=${page}`
    },
    pages (lastPage: number): string {
        return `api/chat/pages/${lastPage}`
    }
}

const collaborationEntries = {
    index: 'api/collaboration'
}

const contact = {
    index: 'api/contact'
}

const downloads = {
    index: 'api/downloads'
}

const hot17 = {
    index: 'api/hot-17',
    reset: 'api/hot-17/reset',
    vote: 'api/hot-17/vote'
}

const news = {
    bySlug (slug: string, params?: SignedRouteParams): string {
        const queryString = params ? `?expires=${params.expires}&signature=${params.signature}` : ''

        return `api/news/show/${slug}${queryString}`
    },
    index (page: number, notPublished = false): string {
        return notPublished ? `api/news?page=${page}&not_published` : `api/news?page=${page}`
    }
}

const pages = {
    show (page: string): string {
        return `api/pages/${page}`
    }
}

const posts = {
    dates: 'api/posts/dates',
    byAuthor (authorId: number, page: number): string {
        return `api/posts/author/${authorId}?page=${page}`
    },
    byDate (date: Date, page: number): string {
        const dateString = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')

        return `api/posts/date/${dateString}?page=${page}`
    },
    byTag (tagSlug: string, page: number): string {
        return `api/posts/tag/${tagSlug}?page=${page}`
    },
    index (page: number): string {
        return `api/posts?page=${page}`
    },
    search (query: string): string {
        return `api/search/${query}`
    }
}

const priceList = {
    index: 'api/price-list'
}

const schedule = {
    index: 'api/schedule'
}

const slides = {
    index: 'api/slides'
}

const staff = {
    editorialCollege: 'api/staff/editorial-college',
    index: 'api/staff'
}

const stream = {
    stats: 'api/stream/stats',
    url: 'api/stream/url'
}

const tags = {
    bySlug (slug: string): string {
        return `api/tags/${slug}`
    }
}

const users = {
    index: 'api/users'
}

const voiceBank = {
    index: 'api/voice-bank'
}

const voiceBankLanguages = {
    index: 'api/voice-bank-languages'
}

const voiceBankTypes = {
    index: 'api/voice-bank-types'
}

export {
    ads,
    blog,
    categories,
    collaborationEntries,
    contact,
    chat,
    downloads,
    hot17,
    news,
    pages,
    posts,
    priceList,
    schedule,
    slides,
    staff,
    stream,
    tags,
    users,
    voiceBank,
    voiceBankLanguages,
    voiceBankTypes
}
